import { render, staticRenderFns } from "./wizard-step.vue?vue&type=template&id=88d6051a&"
import script from "./wizard-step.vue?vue&type=script&lang=js&"
export * from "./wizard-step.vue?vue&type=script&lang=js&"
import style0 from "./_wizard-step.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports